type BrowserLocation = Pick<Location, 'protocol' | 'host' | 'hostname'>;

const TASK_WEBSOCKET_PLACEHOLDER = 'VITE_TASK_WEBSOCKET_URL';
const LOCAL_HOSTNAMES = new Set(['localhost', '127.0.0.1', '::1']);

const getConfiguredTaskWebSocketUrl = (configuredUrl?: string): string | undefined => {
  const candidate = configuredUrl?.trim();
  if (!candidate || candidate === TASK_WEBSOCKET_PLACEHOLDER) {
    return undefined;
  }

  try {
    const parsedUrl = new URL(candidate);
    return parsedUrl.protocol === 'ws:' || parsedUrl.protocol === 'wss:'
      ? candidate
      : undefined;
  } catch {
    return undefined;
  }
};
const resolveTaskWebSocketUrl = (
  location: BrowserLocation | undefined,
  configuredUrl?: string,
): string => {
  const configuredTaskWebSocketUrl = getConfiguredTaskWebSocketUrl(configuredUrl);

  if (location && (!LOCAL_HOSTNAMES.has(location.hostname) || !configuredTaskWebSocketUrl)) {
    const protocol = location.protocol === 'https:' ? 'wss:' : 'ws:';
    return `${protocol}//${location.host}/ws/tasks`;
  }

  return configuredTaskWebSocketUrl ?? 'ws://localhost:8080/ws/tasks';
};

export const ENV_CONFIG = {
  isProduction: globalThis.location?.origin.includes('bpm.grupmontaner.com') ?? false,

  resolveTaskWebSocketUrl,

  getCamundaBaseUrl: () => {
    return import.meta.env.VITE_CAMUNDA_BASE_URL?.trim() || '/engine-rest';
  },

  getBackendApiBaseUrl: () => {
    const camundaBaseUrl = ENV_CONFIG.getCamundaBaseUrl();
    if (camundaBaseUrl.endsWith('/engine-rest')) {
      return `${camundaBaseUrl.slice(0, -'/engine-rest'.length)}/api`;
    }
    return `${camundaBaseUrl}/api`;
  },

  getSSEBaseUrl: () => {
    return import.meta.env.VITE_SSE_BASE_URL?.trim() || '/sse';
  },

  getSSETasksUrl: () => {
    return `${ENV_CONFIG.getSSEBaseUrl()}/tasks`;
  },

  getTaskWebSocketUrl: () => resolveTaskWebSocketUrl(
    globalThis.location,
    import.meta.env.VITE_TASK_WEBSOCKET_URL,
  ),

  env: {
    NODE_ENV: import.meta.env.MODE,
    CAMUNDA_BASE_URL: import.meta.env.VITE_CAMUNDA_BASE_URL,
    SSE_BASE_URL: import.meta.env.VITE_SSE_BASE_URL,
    TASK_WEBSOCKET_URL: import.meta.env.VITE_TASK_WEBSOCKET_URL,
  },
};
